import { Button } from "components/ui/button";

interface InactivateConfirmModalProps {
  campaignName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

export function InactivateConfirmModal({
  campaignName,
  onConfirm,
  onCancel,
  isLoading,
}: InactivateConfirmModalProps) {
  return (
    <div className="p-4">
      <h3 className="text-lg font-medium mb-4">Confirmar Inativação</h3>
      <p className="text-sm text-gray-600 mb-6">
        Tem certeza que deseja inativar a campanha "{campaignName}"? A campanha
        ficará indisponível para uso.
      </p>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onCancel} disabled={isLoading}>
          Cancelar
        </Button>
        <Button variant="destructive" onClick={onConfirm} disabled={isLoading}>
          {isLoading ? "Inativando..." : "Inativar"}
        </Button>
      </div>
    </div>
  );
}
